export const selectStyles = {
  control: (base:any, state:any) => ({
    ...base,
    minHeight: '42px',
    height: 'auto',
    overflowY: 'auto',
    backgroundColor: 'var(--tw-bg-opacity, 1)',
    background: 'var(--select-bg, rgb(31 41 55))',
    borderColor: 'var(--select-border, rgb(75 85 99))',
    boxShadow: 'none',
    borderRadius: '0.5rem',
    '&:hover': {
      borderColor: 'rgb(59 130 246)'
    },
    '&:focus-within': {
      borderColor: 'rgb(59 130 246)',
      boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.3)'
    }
  }),
  valueContainer: (base:any) => ({
    ...base,
    padding: '2px 6px 2px 12px',
    fontSize: '0.875rem',
    flexWrap: 'wrap',
    overflowY: 'auto'
  }),
  input: (base:any) => ({
    ...base,
    margin: '0',
    padding: '0',
    color: 'var(--select-text, rgb(243 244 246))'
  }),
  placeholder: (base:any) => ({
    ...base,
    fontSize: '0.875rem',
    color: 'rgb(156 163 175)'
  }),
  dropdownIndicator: (base:any) => ({
    ...base,
    padding: '0 10px',
    color: 'rgb(156 163 175)',
    '&:hover': {
      color: 'rgb(59 130 246)'
    }
  }),
  clearIndicator: (base:any) => ({
    ...base,
    padding: '0 10px',
    color: 'rgb(156 163 175)',
    '&:hover': {
      color: 'rgb(239 68 68)'
    }
  }),
  multiValue: (base:any) => ({
    ...base,
    backgroundColor: 'var(--select-multi-bg, rgb(55 65 81))',
    borderRadius: '0.25rem',
    margin: '2px 4px 2px 0',
  }),
  multiValueLabel: (base:any) => ({
    ...base,
    color: 'var(--select-multi-text, rgb(243 244 246))',
    fontSize: '0.85rem',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '120px',
  }),
  multiValueRemove: (base:any) => ({
    ...base,
    color: 'rgb(156 163 175)',
    borderRadius: '0 0.25rem 0.25rem 0',
    '&:hover': {
      backgroundColor: 'rgb(153 27 27)',
      color: 'white'
    }
  }),
  singleValue: (base:any) => ({
    ...base,
    color: 'var(--select-text, rgb(243 244 246))',
    fontSize: '0.875rem'
  }),
  menu: (base:any) => ({
    ...base,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    backgroundColor: 'var(--select-bg, rgb(31 41 55))',
    border: '1px solid var(--select-border, rgb(75 85 99))',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    zIndex: 9999
  }),
  menuPortal: (base:any) => ({
    ...base,
    zIndex: 9999
  }),
  menuList: (base:any) => ({
    ...base,
    padding: '4px',
    backgroundColor: 'var(--select-bg, rgb(31 41 55))',
  }),
  option: (base:any, state:any) => ({
    ...base,
    padding: '10px 12px',
    fontSize: '0.875rem',
    backgroundColor: state.isFocused 
      ? 'var(--select-hover, rgb(55 65 81))'
      : state.isSelected 
        ? 'var(--select-active, rgb(55 65 81))'
        : 'var(--select-bg, rgb(31 41 55))',
    color: 'var(--select-text, rgb(243 244 246))',
    '&:hover': {
      backgroundColor: 'var(--select-hover, rgb(75 85 99))'
    },
    cursor: 'pointer',
    borderRadius: '0.25rem'
  }),
  noOptionsMessage: (base:any) => ({
    ...base,
    color: 'rgb(156 163 175)',
    fontSize: '0.875rem'
  })
};

export const selectTheme = (theme:any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'rgb(59 130 246)',
    primary75: 'rgb(75 85 99)',
    primary50: 'rgb(107 114 128)',
    primary25: 'var(--select-active, rgb(55 65 81))',
    danger: 'rgb(220 38 38)',
    dangerLight: 'rgb(127 29 29)',
    neutral0: 'var(--select-bg, rgb(31 41 55))',
    neutral5: 'var(--select-hover, rgb(55 65 81))',
    neutral10: 'var(--select-hover, rgb(55 65 81))',
    neutral20: 'var(--select-border, rgb(75 85 99))',
    neutral30: 'var(--select-border, rgb(75 85 99))',
    neutral40: 'rgb(107 114 128)',
    neutral50: 'rgb(156 163 175)',
    neutral60: 'rgb(209 213 219)',
    neutral70: 'rgb(209 213 219)',
    neutral80: 'rgb(229 231 235)',
    neutral90: 'rgb(243 244 246)'
  }
}); 